import React from 'react';
import { Search, Inbox, Tag, BarChart3 } from 'lucide-react';

const FEATURES = [
  {
    testId: 'landing-solution-search',
    icon: Search,
    badge: 'Buscador Inteligente',
    title: 'El buscador que sí entiende a tus clientes',
    text: 'Soporta errores tipográficos, sinónimos y lenguaje natural. Aumenta la conversión mostrando siempre el producto correcto.',
  },
  {
    testId: 'landing-solution-omnichannel',
    icon: Inbox,
    badge: 'Bandeja Omnicanal',
    title: 'Todo tu soporte en un solo lugar',
    text: 'Unifica WhatsApp, email y pedidos. Respuestas rápidas y chatbots multi-turno con handoff a humano para ahorrar horas de trabajo repetitivo.',
  },
  {
    testId: 'landing-solution-popups',
    icon: Tag,
    badge: 'Popups Dinámicos',
    title: 'Captación de leads que no molesta',
    text: 'Motor de popups inteligentes con cupones dinámicos integrados con Klaviyo y Brevo, mostrados en el momento exacto.',
  },
  {
    testId: 'landing-solution-analytics',
    icon: BarChart3,
    badge: 'Analítica Avanzada',
    title: 'Descubre lo que no estás vendiendo',
    text: 'Analítica de búsquedas sin resultados para identificar oportunidades perdidas y decidir qué stock necesitas de verdad.',
  },
];

export function SolutionBenefit() {
  return (
    <section id="solucion" data-testid="landing-solution-section" className="py-24 md:py-32 px-6 max-w-5xl mx-auto">
      <div className="mb-16 max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white">
          La solución: IA y omnicanalidad fusionadas para escalar sin estrés
        </h2>
      </div>

      <div className="space-y-16">
        {FEATURES.map((f, i) => (
          <div
            key={f.testId}
            data-testid={f.testId}
            className={`flex flex-col md:flex-row items-center gap-10 ${i % 2 === 1 ? 'md:flex-row-reverse' : ''}`}
          >
            <div className="flex-1 flex justify-center">
              <div className="w-40 h-40 rounded-3xl bg-[#0F0F11] border border-[#00E5FF]/20 flex items-center justify-center shadow-[0_0_40px_rgba(0,229,255,0.08)]">
                <f.icon size={48} className="text-[#00E5FF]" />
              </div>
            </div>
            <div className="flex-1 text-left">
              <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#00E5FF] mb-3">
                {f.badge}
              </span>
              <h3 className="text-white font-bold text-2xl mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>{f.title}</h3>
              <p className="text-zinc-400 leading-relaxed">{f.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
